import React from "react";

export default function ResponsivePicture({
  lg,
  lm,
  md,
  sm,
  s,
  styling,
  title,
}) {
  return (
    <picture>
      <source media="(max-width:599px)" srcSet={s} />
      <source media="(min-width: 600px) and (max-width:767px)" srcSet={sm} />
      <source media="(min-width: 768px) and (max-width:1023px)" srcSet={md} />
      <source media="(min-width: 1024px) and (max-width:1439px)" srcSet={lm} />
      <img src={lg} alt={title} className={styling} />
    </picture>
  );
}
